<template>
  <div
    class="product-card"
    data-entity="item"
    :data-id="productId"
  >
    <a :href="detailPageUrl" class="product-card__body">
      <div class="product-card__image">
        <v-picture :image="productImg" :alt="productName" />
      </div>
      <div v-if="productCode" class="product-card__code">
        {{ productCode }}
      </div>
      <h3 class="product-card__name" v-html="productName" />
    </a>
    <div class="product-card__actions">
      <div class="product-card__price-block" data-entity="price-block">
        <h3 class="product-card__price">
          <span class="product-card__price--discount">{{ formattedPriceWithDiscount }}</span>
          <span class="product-card__price--full">{{ formattedPrice }}</span>
        </h3>
        <span class="product-card__price-description">
          {{ productMinCount }}
        </span>
      </div>
      <div class="product-card__buttons" :data-basket-entity="`basket-add-${productId}`">
        <div class="product-card__buttons-item" data-entity="quantity-block">
          <div class="product-card__buttons-calc calc-product">
            <div class="calc-product__action calc-product__less" @click="lessButtonHandler" />
            <div class="calc-product__field">
              <input
                v-model="value"
                type="number"
                :data-min="productPackage"
                data-max="100"
                name="quantity"
                @change="changeInputHandler"
              >
            </div>
            <div class="calc-product__action calc-product__more" @click="moreButtonHandler" />
          </div>
        </div>
        <div class="product-card__buttons-item">
          <button
            class="product-card__buttons-buy _btn _btn--transparent"
            data-goal="add_cart"
            :data-ecommerce-name="productName"
            :data-ecommerce-id="productId"
            :data-ecommerce-price="priceToRubles"
            :data-ecommerce-quantity="value"
            @click="buyButtonHandler"
          >
            <p>Купить</p>
            <span />
          </button>
        </div>
      </div>
      <div class="product-card__buttons" :data-basket-entity="`basket-link-${productId}`">
        <a href="/personal/cart/" class="product-card__buttons-buy _btn">
          <p>Перейти в корзину</p>
          <span />
        </a>
      </div>
      <div class="product-card__icons">
        <svg
          class="product-card__icon compare"
          width="19"
          height="20"
          viewBox="0 0 19 20"
          xmlns="http://www.w3.org/2000/svg"
          data-entity="compare-checkbox"
          :data-id="productId"
        >
          <path
            id="compare-icon"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9 18H10V2H9V18ZM8 0C7.44772 0 7 0.447716 7 1V19C7 19.5523 7.44772 20 8 20H11C11.5523 20 12 19.5523 12 19V1C12 0.447715 11.5523 0 11 0H8ZM2 12V18H3V12H2ZM1 10C0.447715 10 0 10.4477 0 11V19C0 19.5523 0.447715 20 1 20H4C4.55228 20 5 19.5523 5 19V11C5 10.4477 4.55228 10 4 10H1ZM16 18V7H17V18H16ZM14 6C14 5.44772 14.4477 5 15 5H18C18.5523 5 19 5.44772 19 6V19C19 19.5523 18.5523 20 18 20H15C14.4477 20 14 19.5523 14 19V6Z"
          />
        </svg>
        <svg
          class="product-card__icon favorite"
          width="21"
          height="21"
          viewBox="0 0 21 21"
          xmlns="http://www.w3.org/2000/svg"
          data-entity="favorite-checkbox"
          :data-id="productId"
        >
          <path
            id="favorite-icon"
            d="M10.6779 1.30165L13.4115 7.08318L19.7105 7.62043C20.1474 7.65789 20.0421 7.83698 19.7105 8.12187L15.2156 12.5936L16.6474 18.7074C16.7467 19.1322 16.6917 19.2257 16.3164 19L10.4944 15.9995L4.81641 19C4.4401 19.2248 4.24213 19.1313 4.34142 18.7074L5.77318 12.5936L1.30623 8.12187C0.974606 7.83698 0.839476 7.6569 1.27734 7.61944L7.57628 7.0822L10.2701 1.30165C10.4409 0.899452 10.5071 0.899452 10.6779 1.30165Z"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import vPicture from '@/components/v-picture.vue';
import formatPrice from '../../../../../assets/js/helpers/formatPrice';
import addToBasketAPI from './api';
import { storageSet } from '../../../../../assets/js/modules/libs/localStorage';

export default {
  name: 'product-item',

  components: {
    vPicture,
  },

  props: {
    productId: {
      type: Number,
      default: null,
    },
    productName: {
      type: String,
      default: '',
    },
    productNode: {
      type: String,
      default: '',
    },
    productCode: {
      type: String,
      default: '',
    },
    detailPageUrl: {
      type: String,
      default: '',
    },
    productImg: {
      type: Object,
      default: () => {},
    },
    // Приходит в копейках
    productPrice: {
      type: Number,
      default: null,
    },
    unit: {
      type: String,
      default: '',
    },
    // Кратность товара
    productPackage: {
      type: Number,
      default: 1,
    },
    discount: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    value: null,
  }),

  computed: {
    productMinCount() {
      return `заказ от ${this.productPackage} ${this.unit}`;
    },
    priceToRubles() {
      const rubles = Math.floor(this.productPrice / 100);
      const kopecks = this.productPrice % 100;
      return +`${rubles}.${kopecks}`;
    },
    formattedPrice() {
      return `${formatPrice(this.priceToRubles)} ₽`;
    },
    priceWithDiscount() {
      const percentage = 100 - this.discount;
      return (this.priceToRubles * percentage * 0.01).toFixed(2);
    },
    formattedPriceWithDiscount() {
      return `${formatPrice(this.priceWithDiscount)} ₽`;
    },
    productForAnalytic() {
      return {
        name: this.productName || '',
        id: this.productId || '',
        price: this.priceToRubles || 0,
        quantity: this.value || 1,
      };
    },
  },

  mounted() {
    this.value = this.productPackage;
  },

  methods: {
    addAnalyticData() {
      const data = {
        event: 'addToCard',
        ecommerce: {
          currencyCode: 'RUB',
          add: {
            products: [this.productForAnalytic],
          },
        },
      };
      window.dataLayer.push(data);
    },

    lessButtonHandler() {
      if (this.value <= this.productPackage) return;
      this.value -= this.productPackage;
    },

    moreButtonHandler() {
      this.value += this.productPackage;
    },

    changeInputHandler() {
      if (this.value === 0) this.value = this.productPackage;
      else if (this.value % this.productPackage !== 0) {
        const itemCount = Math.trunc(this.value / this.productPackage);

        if (itemCount === 0) {
          this.value = this.productPackage;

          return;
        }

        this.value = this.productPackage * itemCount;
      }
    },

    async buyButtonHandler() {
      const params = {
        id: this.productId,
        quantity: this.value || 1,
      };
      const { data, statusText } = await addToBasketAPI(params);
      if (statusText === 'OK') {
        this.addAnalyticData();

        let basketItems = window.localStorage.getItem('basketItems');
        if (!basketItems) basketItems = [];

        storageSet({ key: 'basketItems', value: data.basketItems });
        window.basketUpdate();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.product-card {
  .product-card__icon {
    path {
      opacity: 1;
    }

    &.compare {
      fill: #474747;
    }

    &.favorite {
      stroke-width: 2;
      fill: #00000000;
      stroke: #474747;
    }

    &.is-active {
      fill: #E30613;
      stroke: #E30613;
    }
  }
}
</style>
